import React, { lazy, Suspense, useEffect } from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";

import { ROUTES } from "./constants/routes.constants";
import useFetchUserInfo from "./apiHooks/fetch-user-info/useFetchUserInfo";
import { ACCESS_TOKEN, API_STATUS } from "./constants/app.constants";

import RoutesLoader from "./common/routes-loader/routes-loader.component";
import Header from "./components/header/header";

const { PRODUCT_DETAILS, PRODUCT_MAIN, HOME, LOGIN, REGISTER, USER_PROFILE, CONTACT_US, SUPPORT_FAQS, THANK_YOU_FOR_REGISTRATION, EMAIL_VERIFIED, FORGOT_PASSWORD, ACCOUNT_SETTINGS , GETTING_STARTED } = ROUTES;

const ProductsContainer = lazy(() => import("./components/products-container/products-container.component"));
const ProductsDetails = lazy( () => import("./components/products-details/products-details.component"));
const PageNotFound = lazy(() => import("./components/404/404.component"));
const RegisterPage = lazy( () => import("./components/register/register-page.component"));
const LoginPage = lazy(() => import("./components/login-page/login-page.component"));
const HomePage = lazy(() => import("./components/home-page/home-page.component"));
const UserProfileContainer = lazy(() => import("./components/user-profile-container/user-profile-container.component"));
const ContactUs = lazy(()=> import("./components/contact-us/contact-us.component"));
const ThankYouForRegistrationPage = lazy(()=> import("./components/thank-you-registration/thank-you-registration.component"));
const EmailVerified = lazy(() => import("./components/email-verified/email-verified.component"));
const SupportFaqsPage = lazy(() => import("./components/support-faqs/support-faqs.component"));
const ForgotPassword = lazy(() => import("./components/forgot-password/forgot-password.component"));
const AccountSettings = lazy(()=> import("./components/account-settings/account-settings.component"));
const GettingStarted = lazy(()=> import("./components/getting-started/getting-started.component"));

const Routes = () => {

	const { fetchUserInfo, status: userInfoStatus, content } = useFetchUserInfo();

	useEffect(() => {
		if (userInfoStatus !== API_STATUS.SUCCESS && localStorage.getItem(ACCESS_TOKEN)) {
			
			fetchUserInfo(localStorage.getItem(ACCESS_TOKEN))
		}
	}, []);

	const routes = [
		{
			path: PRODUCT_MAIN,
			exact: true,
			enabled: true,
			component: ProductsContainer
		},
		{
			path: PRODUCT_DETAILS,
			exact: true,
			enabled: true,
			component: ProductsDetails,
		},
		{
			path: HOME,
			exact: true,
			enabled: true,
			component: HomePage
		},
		{
			path: LOGIN,
			exact: true,
			enabled: true,
			component: LoginPage
		},
		{
			path: REGISTER,
			exact: true,
			enabled: true,
			component: RegisterPage
		},
		{
			path: USER_PROFILE,
			exact: true,
			enabled: true,
			component: UserProfileContainer
		},
		{
			path: CONTACT_US,
			exact: true,
			enabled: true,
			component: ContactUs
		},
		{
			path: THANK_YOU_FOR_REGISTRATION,
			exact: true,
			enabled: true,
			component: ThankYouForRegistrationPage
		},
		{
			path: EMAIL_VERIFIED ,
			exact: true,
			enabled: true,
			component: EmailVerified
		},
		{
			path: SUPPORT_FAQS,
			exact: true,
			enabled: true,
			component: SupportFaqsPage
		},
		{
			path: FORGOT_PASSWORD,
			exact: true,
			enabled: true,
			component: ForgotPassword
		},
		{
			path: ACCOUNT_SETTINGS,
			exact: true,
			enabled: true,
			component: AccountSettings
		},
		{
			path: GETTING_STARTED,
			exact: true,
			enabled: true,
			component: GettingStarted
		},
		{
			path: "*",
			component: PageNotFound
		}


	]
	return (

		<Router>
			<Header />
			<Suspense fallback={<RoutesLoader />}>
			<Switch>
				{routes.map(({ path, component, ...otherProps }) => {
					const Component = component;
					return (

						<Route key={path} path={path} {...otherProps}>

							<Component />
						</Route>

					);
				})}
			</Switch>
</Suspense>

		</Router>
	)
}

export default Routes;